import { useParams, Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { useCallback, useLayoutEffect, useMemo } from "react";
import moment from "moment";
import { FetchReferrerTransactions } from "@/redux/features/actions/referrers";
import { DASHBOARD_REFFERS_ROUTE } from "@/helpers/routes";
import { ColumnDef } from "@tanstack/react-table";
import DataTable from "../table2";
import { getDataType } from "../table2/types";

export default function ReferrerTransactions() {
  const { referrerId } = useParams<{ referrerId: string }>();
  const dispatch = useAppDispatch();
  const { transactions }: any = useAppSelector((s) => s.referers);

  console.log(transactions);

  const columns = useMemo<ColumnDef<any>[]>(
    () => [
      {
        accessorFn: (row) => row?.phone_number,
        header: "Phone Number",
      },
      {
        accessorFn: (row) => row?.amount,
        header: "Amount",
        cell: ({ getValue }) => `MWK ${getValue()}`,
      },
      {
        accessorFn: (row) => row?.discount_code,
        header: "Discount Code",
      },
      {
        accessorFn: (row) => row?.discount_type,
        header: "Discount Type",
      },
      {
        accessorFn: (row) => row?.final_amount,
        header: "Final Amount",
        cell: ({ getValue }) => `MWK ${getValue()}`,
      },
      {
        accessorFn: (row) => row?.status,
        header: "Status",
        cell: ({ getValue }) => {
          const value = getValue() as string;
          return (
            <span
              className={`${
                value?.toLowerCase() === "success"
                  ? "text-green-600"
                  : value?.toLowerCase() === "pending"
                    ? "text-orange-500"
                    : "text-red-600"
              }`}
            >
              {value?.toLowerCase()}
            </span>
          );
        },
      },
      {
        accessorFn: (row) => row?.telco,
        header: "Telco",
      },
      {
        accessorFn: (row) => row?.created_at,
        header: "Created At",
        cell: ({ getValue }) => moment(getValue() as string).format("LLL"),
      },
    ],
    [],
  );

const getData = useCallback(
  async ({ options, type }: Partial<getDataType> = {}) => {
    try {
      // Common params setup
      const baseParams = {
        ...options?.filters,
        pageNumber: (options?.pagination?.pageIndex || 0) + 1, // Convert to 1-based
      };

      if (type === "export") {
        // For exports, use total as pageSize to get all records
        const exportParams = {
          ...baseParams,
          pageSize: options?.pagination?.total || 1000, // Fallback if total not available
        };

        const exportResponse = await dispatch(
          FetchReferrerTransactions({ 
            referrerId, 
            ...exportParams 
          })
        ).unwrap();

        // Return just the transactions array for exports
        return exportResponse.list?.transactions || [];
      }

      // For regular paginated requests
      const regularParams = {
        ...baseParams,
        pageSize: options?.pagination?.pageSize || 10,
      };

      const response = await dispatch(
        FetchReferrerTransactions({ 
          referrerId, 
          ...regularParams 
        })
      ).unwrap();

      // Return structured pagination data for regular requests
      return response.list.transactions || []
    } catch (error: any) {
      console.error("Error fetching transactions:", error);
      return type === "export" 
        ? [] 
        : {
            data: [],
            total: 0,
            pageCount: 0,
            pageIndex: 0,
            pageSize: 10,
          };
    }
  },
  [dispatch, referrerId]
);
  useLayoutEffect(() => {
    getData({});
  }, [getData]);

  // const onFilter = useCallback(
  //   (filters: any) => {
  //     const data = {
  //       ...filters,
  //       to: !filters?.to
  //         ? ""
  //         : moment(filters?.to)
  //             .add(moment(filters?.to).format("HH") === "23" ? 0 : 86369, "seconds")
  //             .format("YYYY-MM-DD HH:mm"),
  //     };

  //     getData(data);
  //   },
  //   [getData]
  // );

  // const more = useCallback(
  //   (number?: number) => {
  //     getData({ ...filters, pageNumber: (transactions?.currentPage || 0) + (number || 1) });
  //   },
  //   [filters, getData, transactions?.currentPage]
  // );
  console.log(transactions);

  return (
    <div className="p-4">
      <div className="mb-4">
        <Link to={DASHBOARD_REFFERS_ROUTE} className="text-blue-500 hover:text-blue-700">
          &larr; Back to All Referrers
        </Link>
      </div>

      <DataTable<any>
        title="Referrer Transactions"
        columns={columns}
        data={transactions?.list?.transactions ?? []}
        getData={getData}
        customPagination
        pagination={{
          totalPages: transactions?.lastPage,
          pageNumber: (transactions?.currentPage || 1) - 1,
          pageSize: transactions?.pageSize,
          total: transactions?.total,
        }}
        // totalResults={transactions?.total}
        allowExport
        // minimizeFilter
        // hidePageSizeSelector
        // getMore={more}
        // onFilter={onFilter}
        // customPaginationActions
        // hideSearch
        // currentPage={transactions?.currentPage}
      />
    </div>
  );
}
